import { fg } from '@atlassian/jira-feature-gating';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { helpCenterSettingsArticlesViewArticleRoute } from '@atlassian/jira-router-routes-help-center-settings-routes/src/helpCenterSettingsArticlesViewArticleRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { navigation } from './common/constants.tsx';
import { helpCenterSettingViewArticleAppPageEntryPoint } from './ui/articles-view-article/index.tsx';

export const helpCenterSettingsArticlesViewArticleRouteEntry = createEntry(
	helpCenterSettingsArticlesViewArticleRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.articles-view-article',
		layout: serviceProjectLayout,
		navigation,
		component: ErrorPagesNotFound,
		entryPoint() {
			return fg('enable_articles_page_csm')
				? helpCenterSettingViewArticleAppPageEntryPoint
				: undefined;
		},
		resources: [...getServiceDeskSettingsResources()],
	}),
);
